import React, { memo, useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { EmbeddedTimesheet } from './embeddedTimesheet';
import { SmartDiaryNotes } from './smartDiaryNotes';
import { useTimesheetPeriod } from './smartDiaryNotes/hooks';
import { SmartDiaryNotesSkeleton } from './smartDiaryNotes/SmartDiaryNotesSkeleton';
import SmartTimesheetPanel from './SmartTimesheetPanel';

const useStyles = makeStyles((theme) => ({
  skeletonContainer: { paddingRight: theme.spacing(1) }
}));
export const SmartDiaryPage: React.FC = () => {
  const classes = useStyles();

  const { loading, loadMore } = useTimesheetPeriod();

  const { smartDiaryNotes } = useMemo(
    () => ({
      smartDiaryNotes: <SmartDiaryNotes loadMorePeriods={loadMore} />,
      embeddedTimesheet: <EmbeddedTimesheet />
    }),
    [loadMore]
  );

  const embeddedTimesheetWrappedWithContextProvider = useMemo(() => {
    return <EmbeddedTimesheet />;
  }, []);

  return (
    <SmartTimesheetPanel
      sidePanelContent={
        loading ? (
          <div className={classes.skeletonContainer}>
            <SmartDiaryNotesSkeleton />
          </div>
        ) : (
          smartDiaryNotes
        )
      }
      content={embeddedTimesheetWrappedWithContextProvider}
    />
  );
};

SmartDiaryPage.displayName = 'SmartDiaryPage';

export default memo(SmartDiaryPage);
